import { ReactElement } from 'react';

import { useWindowSizeStore } from '../../../stores/useWindowSizeStore';
import { DadosEmpresaContent } from './MainPurchaseSummaryContent';

interface Props {
  isPurchaseSummaryOpen?: boolean;
}

export function ContentHandlerPurchaseSummary({
  isPurchaseSummaryOpen,
}: Props): ReactElement {
  const width = useWindowSizeStore(state => state.width);

  if (width >= 748) {
    return <DadosEmpresaContent />;
  }

  if (isPurchaseSummaryOpen) {
    return <DadosEmpresaContent />;
  }

  return <></>;
}
